import { render, staticRenderFns } from "./TicketPrintModel.vue?vue&type=template&id=5dade040"
import script from "./TicketPrintModel.vue?vue&type=script&lang=js"
export * from "./TicketPrintModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports